import React from 'react';

import { DangerText } from '../ContractText';

interface EqualSellerandBuyerFeeProps {
  buyerAgentCompensation?: number;
  offerPrice?: number;
}
const EqualSellerandBuyerFee = ({
  buyerAgentCompensation,
  offerPrice,
}: EqualSellerandBuyerFeeProps) => {
  return (
    <span>
      Seller to credit buyers agent compensation of {buyerAgentCompensation}% of{' '}
      ${offerPrice} to buyer at closing, covering first the Unbeatable Loans LLC
      fee, followed by other closing costs.
    </span>
  );
};

export default EqualSellerandBuyerFee;
